import { useCallback, useMemo } from 'react'
import { Globe } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchJurisdictions, LEGAL_KIND_OPTS, LEGAL_STATUS_OPTS, LEGAL_STR as S, type LegalRow } from './legalFlowApi'

/**
 * A19.04 — Yurisdiksiya (jurisdiction, read-only). So'rovlar yurisdiksiya va
 * so'ragan organ kesimida. GET /admin/legal ustidan (yurisdiksiya bo'yicha
 * tartiblangan). Backend yo'q/xato → fail-soft.
 */
export function LegalJurisdictionScreen() {
  const columns = useMemo<AdminColumn<LegalRow>[]>(
    () => [
      { key: 'id', header: S.id, type: 'id', width: 70 },
      { key: 'jurisdiction', header: S.jurisdiction, type: 'text', minWidth: 160 },
      { key: 'authority', header: S.authority, type: 'text', minWidth: 180 },
      { key: 'kind', header: S.kind, type: 'enum', width: 140, options: LEGAL_KIND_OPTS },
      { key: 'reference', header: S.reference, type: 'text', width: 150 },
      { key: 'status', header: S.status, type: 'enum', width: 130, options: LEGAL_STATUS_OPTS },
      { key: 'created_at', header: S.created, type: 'date', width: 150 },
    ],
    [],
  )
  const fetcher = useCallback(fetchJurisdictions, [])
  return (
    <>
      <PageHeader title={S.jurisdictionTitle} screenId="A19.04" description={S.jurisdictionDesc} />
      <DataTable<LegalRow>
        screenId="A19.04"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <Globe size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
